import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./config/AuthProvider";
import { NavigationProvider } from "./context/NavigationContext";
import "./index.css";
import { GlobalFiltersProvider } from "./providers/GlobalFiltersProvider";
import { queryClient } from "./react-query-client";

const baseUrl = document.getElementsByTagName("base")[0]?.getAttribute("href") || "/";
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <GlobalFiltersProvider>
      <AuthProvider>
        <BrowserRouter basename={baseUrl}>
          <NavigationProvider>
            <App />
          </NavigationProvider>
        </BrowserRouter>
      </AuthProvider>
    </GlobalFiltersProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);